import { useCallback } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import type { Market } from '@//config/domain-locale-map';
import { useLegacyTracking } from '@//providers/LegacyTrackingProvider';
import { useMarket } from '@//providers/MarketSettingsProvider';
import type { LegacyTrackImagesFullscreenClickEventData } from './legacy-types';
import { useLegacyTrackShownInterest } from './useLegacyTrackShownInterest';
import { mapElasticVehicleToLegacyItem } from './utils';

export const createLegacyTrackImagesFullscreenClick = (
  market: Market,
  vehicle: ElasticVehicle,
): LegacyTrackImagesFullscreenClickEventData => {
  const eventData: LegacyTrackImagesFullscreenClickEventData = {
    eventType: 'microConversion',
    conversionType: 'imagesFullscreenClick',
    item: mapElasticVehicleToLegacyItem(market, vehicle),
    pageType: 'product page',
  };

  return eventData;
};

export const useLegacyTrackImagesFullscreenClick = () => {
  const market = useMarket();
  const { track } = useLegacyTracking();
  const { trackLegacyShownInterest } = useLegacyTrackShownInterest();

  const trackLegacyImagesFullscreenClick = useCallback(
    (vehicle: ElasticVehicle) => {
      trackLegacyShownInterest(vehicle);
      track({
        event: 'microConversion',
        data: createLegacyTrackImagesFullscreenClick(market, vehicle),
      });
    },
    [market, track],
  );

  return {
    trackLegacyImagesFullscreenClick,
  };
};
